// 세션 관리를 위한 유틸리티

// JWT 토큰 디코딩 (간단한 구현)
export const decodeToken = (token: string): any => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('토큰 디코딩 실패:', error);
    return null;
  }
};

// 토큰 만료 시간 확인
export const isTokenExpired = (token: string): boolean => {
  const decodedToken = decodeToken(token);
  if (!decodedToken || !decodedToken.exp) {
    return true;
  }
  
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};

// 토큰 만료까지 남은 시간 (초)
export const getTokenTimeLeft = (token: string): number => {
  const decodedToken = decodeToken(token);
  if (!decodedToken || !decodedToken.exp) {
    return 0;
  }
  
  const currentTime = Date.now() / 1000;
  return Math.max(0, decodedToken.exp - currentTime);
};

// 로컬 스토리지에서 토큰 가져오기
export const getStoredToken = (): string | null => {
  return localStorage.getItem('access_token');
};

// 토큰 유효성 검사
export const isValidToken = (): boolean => {
  const token = getStoredToken();
  if (!token) {
    return false;
  }
  
  return !isTokenExpired(token);
};

// 세션 정리
export const clearSession = (): void => {
  localStorage.removeItem('access_token');
  // 필요한 경우 다른 세션 데이터도 정리
};

// 자동 로그아웃 타이머 설정
export const setupAutoLogout = (onLogout: () => void): (() => void) => {
  const token = getStoredToken();
  if (!token || isTokenExpired(token)) {
    onLogout();
    return () => {};
  }
  
  const timeLeft = getTokenTimeLeft(token);
  // 토큰 만료 5분 전에 경고, 만료 시점에 로그아웃
  const warningTime = Math.max(0, (timeLeft - 300) * 1000); // 5분 전
  const logoutTime = timeLeft * 1000;
  
  let warningTimer: NodeJS.Timeout | null = null;
  let logoutTimer: NodeJS.Timeout | null = null;
  
  if (warningTime > 0) {
    warningTimer = setTimeout(() => {
      console.warn('세션이 5분 후에 만료됩니다.');
      // 필요한 경우 사용자에게 알림 표시
    }, warningTime);
  }
  
  logoutTimer = setTimeout(() => {
    onLogout();
  }, logoutTime);
  
  // 타이머 정리 함수 반환
  return () => {
    if (warningTimer) clearTimeout(warningTimer);
    if (logoutTimer) clearTimeout(logoutTimer);
  };
};